import dayjs from '~/timeInit';

import { FlashAvailability } from '~/hooks/apis/calendar/useFlashAvailability';

import { BUNDLE_OCCUPANCIES } from '~/types/bundles/bundle';

/** A hotel component checks in dayOffset days after the bundle's departure date. */
export function checkInDate(departureDate: string, dayOffset: number): string {
  return dayjs(departureDate).add(dayOffset, 'day').format('YYYY-MM-DD');
}

/**
 * - `available`: every occupancy the bundle sells has a room on that check-in.
 * - `soldOut`: the calendar shows no rooms for at least one occupancy.
 * - `noRates`: the calendar has nothing for that check-in (outside its range, or off sale).
 * Only `available` can be sold. Undefined while it is still being checked.
 */
export type HotelStatus = 'available' | 'soldOut' | 'noRates';

export function hotelStatus(availability: FlashAvailability | undefined, checkIn: string): HotelStatus | undefined {
  if (!availability) return undefined;
  const rooms = BUNDLE_OCCUPANCIES.map((occupancy) => availability[occupancy]?.[checkIn]?.rooms);
  if (rooms.some((count) => count === undefined)) return 'noRates';
  return rooms.every((count) => count > 0) ? 'available' : 'soldOut';
}
